import React, { useEffect, useState } from "react";
import { fetchIgoFavorites } from "../../HTTP/articles";
import { htmlDecode, getDomainName } from "../../Helper/utils";

const IgoFavoritesButton = ({ igoId, igoName, userId }) => {
	const [open, setOpen] = useState(false);
	const [loading, setLoading] = useState(true);
	const [items, setItems] = useState([]);

	useEffect(() => {
		let alive = true;
		setLoading(true);
		fetchIgoFavorites(igoId, userId)
			.then((result) => {
				if (alive) setItems(Array.isArray(result) ? result : []);
			})
			.catch(() => {
				if (alive) setItems([]);
			})
			.finally(() => {
				if (alive) setLoading(false);
			});
		return () => {
			alive = false;
		};
	}, [igoId, userId]);

	if (items.length === 0) return null;

	return (
		<>
			<button
				type="button"
				className="border-2 border-cyan-600 text-cyan-700 px-3 py-1 rounded text-sm"
				onClick={() => setOpen(true)}
			>
				Voir les favoris partagés
			</button>
			{open && (
				<div
					className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
					onClick={() => setOpen(false)}
				>
					<div
						className="bg-white rounded-lg shadow-lg p-6 w-full max-w-3xl max-h-[80vh] overflow-y-auto"
						onClick={(e) => e.stopPropagation()}
					>
						<div className="flex justify-between items-center mb-4">
							<h3 className="text-lg font-bold">Articles favoris{igoName ? ` - ${igoName}` : ""}</h3>
							<button type="button" className="text-xl px-2" onClick={() => setOpen(false)} aria-label="Fermer">×</button>
						</div>
						{loading ? (
							<p>Chargement…</p>
						) : items.length === 0 ? (
							<p>Aucun article ajouté pour ce forum.</p>
						) : (
							<div className="allArticlesDiv" style={{ height: "50vh", overflowY: "scroll" }}>
								{items.map((fav, index) => (
									<div className="featuresfav" key={fav.id ?? fav.link ?? index}>
										<div className="itemfav rounded-lg shadow m-2">
											<div className="item-photowrapper">
												<img
													className="item-photofav"
													src={htmlDecode(fav.image || process.env.PUBLIC_URL + "/news_icon2.jpg")}
													alt="article"
													onClick={() => window.open(htmlDecode(fav.link), "_blank")}
												/>
											</div>
											<div className="arttfav">
												<div className="item-headerfav"></div>
												<a href={htmlDecode(fav.link)} target="_blank" rel="noreferrer" style={{ textDecoration: "inherit", color: "inherit" }}>
													<h3 className="item-titlefav">{htmlDecode(fav.title)}</h3>
													<p>
														<strong className="text-cyan-600">
															{getDomainName(fav.link) === "static.zemus.info" ? "Article - " : "Recherche - "}
															Pays : {htmlDecode(fav.country)} | Source : {getDomainName(fav.link)}
														</strong>
													</p>
													<p className="item-textfav">{htmlDecode(fav.description)}</p>
												</a>
											</div>
										</div>
									</div>
								))}
							</div>
						)}
					</div>
				</div>
			)}
		</>
	);
};

export default IgoFavoritesButton;
